import React, { useState } from 'react';
import { Container, Paper, Grid, Typography, Box, Chip, Collapse, IconButton } from '@mui/material';
import { Work, School, Engineering, EmojiEvents, Language, Code, ExpandMore, ExpandLess } from '@mui/icons-material';
import { CVSection } from '../components/cv/CVSection';
import { CVCard } from '../components/cv/CVCard';
import { experiences, research, education, extracurricular, technicalSkills } from '../data/cvData';

export const CV: React.FC = () => {
    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <CVSection title="Education">
                {education.map((edu, index) => (
                    <CVCard
                        key={index}
                        icon={School}
                        title={edu.school}
                        subtitle={edu.degree}
                        period={edu.period}
                        location={edu.location}
                        points={edu.points}
                    />
                ))}
            </CVSection>

            <CVSection title="Experience">
                {experiences.map((exp, index) => (
                    <CVCard
                        key={index}
                        icon={Work}
                        title={exp.title}
                        subtitle={exp.company}
                        period={exp.period}
                        location={exp.location}
                        points={exp.points}
                    />
                ))}
            </CVSection>

            <CVSection title="Research">
                {research.map((res, index) => (
                    <CVCard
                        key={index}
                        icon={Engineering}
                        title={res.title}
                        subtitle={res.organization}
                        period={res.period}
                        location={res.location}
                        points={res.points}
                    />
                ))}
            </CVSection>

            <CVSection title="Extracurricular Activities">
                {extracurricular.map((activity, index) => (
                    <CVCard
                        key={index}
                        icon={EmojiEvents}
                        title={activity.title}
                        subtitle={activity.organization}
                        period={activity.period}
                        location={activity.location}
                        points={activity.points}
                    />
                ))}
            </CVSection>

            <CVSection title="Technical Skills">
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                            <Language sx={{ mr: 1 }} /> Languages
                        </Typography>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            {technicalSkills.languages.map((skill) => (
                                <Chip key={skill} label={skill} color="primary" variant="outlined" />
                            ))}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                            <Code sx={{ mr: 1 }} /> Frameworks
                        </Typography>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            {technicalSkills.frameworks.map((skill) => (
                                <Chip key={skill} label={skill} color="secondary" variant="outlined" />
                            ))}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Typography variant="h6" gutterBottom>
                            Developer Tools
                        </Typography>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            {technicalSkills.developerTools.map((skill) => (
                                <Chip key={skill} label={skill} color="info" variant="outlined" />
                            ))}
                        </Box>
                    </Grid>
                </Grid>
            </CVSection>
        </Container>
    );
};

export default CV;
